import React, { useState } from 'react';
import { LoadSpinner } from '../../LoadSpinner';
import "./FileUploader.scss"


export function FileUploader(props: {
    text: string,
    onSet: (file: File) => Promise<any>
}) {

    const [isBusy, setIsBusy] = useState(false);

    async function onDrop(evt: React.DragEvent) {
        evt.preventDefault();
        if (isBusy)
            return;
        const file = getFirstFile(evt);
        if (!file)
            return;
        setIsBusy(true);

        try {
            await props.onSet(file);
        }
        finally {
            setIsBusy(false);
        }
    }

    function onDragOver(evt: React.DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.dataTransfer.dropEffect = "copy";
    }



    return (
        <div className="file-uploader"
            onDragOver={onDragOver}
            onDrop={onDrop}
        >
            { isBusy ? <LoadSpinner /> : <span>{props.text}</span> }
        </div>
	);
}

function getFirstFile(evt: React.DragEvent) {
    if (!evt.dataTransfer.items)
        return;
    for (let i = 0; i < evt.dataTransfer.items.length; i++) {
        let item = evt.dataTransfer.items[i];
        if (item.kind === "file") {
            return item.getAsFile();
        }
    }
    return;
}
